import React from "react";
import styles from "../assets/CSS/Experience.module.css";
import history from "../data/history.json";
import colorSharp from "../assets/img/color-sharp2.png";

export const Experience = () => {
  return (
    <section className={styles.container} id="experience">
      <h2 className={styles.title}>Experience</h2>
      <div className={styles.content} id="experienceitem">
        <ul className={styles.history} id="experienceitem">
          {history.map((historyItem, id) => {
            return (
              <li key={id} className={styles.historyItem} id="experienceitem" >
                <img
                  src={historyItem.imageSrc}
                  alt={`${historyItem.organisation} Logo`}
                />
                <div className={styles.historyItemDetails}>
                  <h3>{`${historyItem.role}, ${historyItem.organisation}`}</h3>
                  <p>{`${historyItem.startDate} - ${historyItem.endDate}`}</p>
                  <ul>
                    {historyItem.experiences.map((experience, idx) => (
                      <li key={idx}>{experience}</li>
                    ))}
                  </ul>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Background" />
    </section>
  );
};
